/**
 * Detalle de una métrica de estadísticas.
 */
import React, { useState } from 'react';
import { ink, studio } from './studioUi';

const formatTimestamp = (timestamp) => {
    if (!timestamp) return '—';
    const date = timestamp.toDate
        ? timestamp.toDate()
        : timestamp._seconds
            ? new Date(timestamp._seconds * 1000)
            : new Date(timestamp);
    if (Number.isNaN(date.getTime())) return 'Fecha inválida';
    return date.toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' });
};

const StatsDetailModal = ({ show, onClose, title, data, columns, loading }) => {
    const [hovered, setHovered] = useState(null);
    if (!show) return null;

    const count = data?.length || 0;

    return (
        <div style={ui.overlay} onClick={onClose} role="presentation">
            <div
                role="dialog"
                aria-modal="true"
                aria-label={title}
                style={ui.sheet}
                onClick={(event) => event.stopPropagation()}
            >
                <div style={ui.head}>
                    <div>
                        <p style={studio.kicker}>Detalle</p>
                        <h3 style={{ ...studio.formTitle, margin: '6px 0 0' }}>{title}</h3>
                        <p style={{ ...studio.hint, marginTop: 6 }}>
                            {loading
                                ? 'Cargando registros…'
                                : count
                                    ? `${count} ${count === 1 ? 'registro' : 'registros'}`
                                    : 'Sin registros'}
                        </p>
                    </div>
                    <button type="button" onClick={onClose} style={studio.ghostBtn}>Cerrar</button>
                </div>

                {loading ? (
                    <div style={studio.empty}>Cargando…</div>
                ) : !count ? (
                    <div style={studio.empty}>No hay datos para mostrar.</div>
                ) : (
                    <div style={ui.scroll}>
                        <table style={studio.table}>
                            <thead>
                                <tr>
                                    {columns.map((col) => (
                                        <th key={col.key} style={studio.th}>{col.header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr
                                        key={index}
                                        style={hovered === index ? studio.trHover : undefined}
                                        onMouseEnter={() => setHovered(index)}
                                        onMouseLeave={() => setHovered(null)}
                                    >
                                        {columns.map((col) => (
                                            <td key={col.key} style={studio.td}>
                                                {col.isDate ? formatTimestamp(item[col.key]) : (item[col.key] ?? '—')}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

const ui = {
    overlay: {
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(28, 29, 33, 0.45)',
        zIndex: 40,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    sheet: {
        ...studio.card,
        width: 'min(920px, 100%)',
        maxHeight: '82vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 24px 64px rgba(28, 29, 33, 0.22)',
    },
    head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 16,
        marginBottom: 16,
    },
    scroll: {
        overflow: 'auto',
        maxHeight: '58vh',
        border: `1px solid ${ink.line}`,
        borderRadius: 12,
    },
};

export default StatsDetailModal;
